// https://help.consentmanager.net/books/cmp/page/cmp-events

__cmp("addEventListener",["consent",function () {
  const consentDetail = __cmp('getCMPData');

  if (consentDetail) {
    // If "Shopify Tracking" service is allowed by the customer,
    // set Shopify tracking consent to "true"
    window.Shopify.loadFeatures(
      [{
        name: 'consent-tracking-api',
        version: '0.1',
      }],
      () => {
        if (getConsent('Shopify International Limited (Tracking)', consentDetail)) {
          window.Shopify.customerPrivacy.setTrackingConsent(true, () => {});
        } else {
          window.Shopify.customerPrivacy.setTrackingConsent(false, () => {});
        }
      }
    );

    if (window.initialConsentSet) {
      // If any consent is revoked, reload the page to "stop" the scripts
    } else {
      // This is the initial cookie selection of the user
      window.initialConsentSet = true;
    }
  }
  
  document.querySelectorAll('[data-usercentrics]').forEach((el) => {
    const serviceName = el.getAttribute('data-usercentrics');
    const consentAccepted = getConsent(serviceName, consentDetail);

    if (consentAccepted) {
      if (el.tagName.toLowerCase() == 'iframe') {
        el.setAttribute('src', el.getAttribute('data-src'));
      } else {
        el.type = "text/javascript";
      }
      el.removeAttribute('data-usercentrics');
    }
  });
} ,false],null);

__cmp("addEventListener",["consentrejected",function (e,o) {
  if (window.initialConsentSet) {
    window.location.reload();
  }
} ,false],null);

// Monkey-patching document.createElement
// https://github.com/elbywan/yett/blob/master/src/monkey.js
const createElementBackup = document.createElement;
const TYPE_ATTRIBUTE = 'text/plain';

// Map script sources to services
const getServiceName = function (src) {
  if (src) {
    switch (true) {
      case /fonts.gstatic.com/.test(src):
        return 'Google Fonts';
      case /maps.gstatic.com/.test(src):
        return 'Google Maps';
      case /www.youtube.com/.test(src):
        return 'YouTube';
      case /connect.facebook.net/.test(src):
        return 'Facebook (Meta)';
      case /google-analytics.com/.test(src):
      case /analytics.google.com/.test(src):
        return 'Google Analytics';
      case /www.googletagmanager.com/.test(src):
        return 'Google Tag Manager';
      case /ip.lovely-app.com/.test(src):
        return 'Lovely Apps GmbH & CO. KG';
      case /geo.lovely-app.com/.test(src):
        return 'Lovely Apps GmbH & CO. KG';
    }
  }
};

const getConsent = function (service, consentDetail) {
  if (consentDetail && consentDetail.vendorsList && consentDetail.vendorConsents) {
    const vendor = consentDetail.vendorsList.find(vendor => vendor.name === service);
    if (!vendor) {
      return true; //Dont block services that are not in the list
    }
    const consent = consentDetail.vendorConsents[vendor.id];
    return consent === true;
  }
  return false
}


const originalDescriptors = {
  href: Object.getOwnPropertyDescriptor(HTMLLinkElement.prototype, 'href'),
};

// Monkey patch the createElement method to prevent dynamic scripts from executing
document.createElement = function (...args) {
  // If this is not a script tag, bypass
  if (args[0].toLowerCase() !== 'script' && args[0].toLowerCase() !== 'link') return createElementBackup.bind(document)(...args);

  const scriptElt = createElementBackup.bind(document)(...args);

  // Define getters / setters to ensure that the script type is properly set
  try {
    Object.defineProperties(scriptElt, {
      href: {
        get() {
          return originalDescriptors.href.get.call(this);
        },
        set(value) {
          originalDescriptors.href.set.call(this, value);
        }
      },
    });

    scriptElt.setAttribute = function (name, value) {
      if(name === 'src') {
        // Prevent loading for specific services
        const serviceName = getServiceName(value);
        if (serviceName) {
          const consentDetail = __cmp('getCMPData');
          const consentAccepted = getConsent(serviceName, consentDetail);

          if (!consentAccepted) {
            scriptElt.type = TYPE_ATTRIBUTE;
            scriptElt.setAttribute('data-usercentrics', getServiceName(value));
          }
        }
      }
      
      // Monkey patch the setAttribute function so that the setter is called instead
      if (name === 'href') scriptElt[name] = value;
      else (args[0] === 'script' ? HTMLScriptElement : HTMLLinkElement).prototype.setAttribute.call(scriptElt, name, value);
    };
  } catch (error) {
    console.error(error);
  }

  return scriptElt;
};


document.addEventListener('DOMContentLoaded', function () {
  const els = document.querySelectorAll('script[src], iframe');
  const consentDetail = __cmp('getCMPData');
  els.forEach(function (el) {
    const value = el.getAttribute('src');

    const serviceName = getServiceName(value);
    if (serviceName) {
      const consentAccepted = getConsent(serviceName, consentDetail);

      if (!consentAccepted) {
        el.setAttribute('data-src', value);
        el.removeAttribute('src');
        el.setAttribute('data-usercentrics', serviceName);

        if(serviceName == "YouTube") {
          new ConsentOverlay(el, el.getAttribute('data-usercentrics'));
        }
      }
    }
  });
});

class ConsentOverlay {
  constructor(element, service) {
    if(!element || !service) { return; }
    this.element = element;
    this.service = service;
    if(window.initialConsentSet && this.isServiceAccepted(service)) {
      this.removeOverlay();
    } else {
      if(window.initialConsentSet) {
        this.createOverlay();
      }

      const that = this;
      __cmp("addEventListener",["consent",function () {
        if(that.isServiceAccepted(service)) {
          that.removeOverlay();
        } else if(!that.overlay) {
          that.createOverlay();
        }
      } ,false],null);
    }
  }

  createOverlay() {
    this.overlay = document.createElement('div');
    this.overlay.className = 'modal consent-modal';
    this.overlay.setAttribute('open', true);

    this.overlay.innerHTML = `
        <div class="modal__overlay"></div>

        <div class="modal__content">
          <strong>${window.themeVariables.strings.consentModalTitle.replace("{{service}}", this.service)}</strong>
          <p>${window.themeVariables.strings.consentModalDescription}</p>
          <div class="consent-buttons">
            <button class="button button--primary acceptBtn">${window.themeVariables.strings.consentModalAccept}</button>
          </div>
        </div>
    `;

    this.overlay.querySelector('.acceptBtn')?.addEventListener('click', () => this.onAccept());
    let insertBefore = this.element;
    let parent = this.element.parentNode;
    if (window.getComputedStyle(this.element).position === 'absolute' && parent.style.paddingBottom.indexOf('%') != -1) {
      while (parent.style.paddingBottom.indexOf('%') != -1) {
        insertBefore = parent;
        parent = parent.parentNode;
      }
    }
    parent.insertBefore(this.overlay, insertBefore);
  }

  onAccept() {
    __cmp('setVendorConsent',[this.getServiceId(this.service), 1 ]);
    this.removeOverlay();
  }

  getServiceId (service) {
    const consentDetail = __cmp('getCMPData');
    const vendor = consentDetail.vendorsList.find(vendor => vendor.name === service);
    return vendor ? vendor.id : null;
  }

  isServiceAccepted (service) {
    const consentDetail = __cmp('getCMPData');
    return getConsent(service, consentDetail);
  }

  removeOverlay() {
    if(this.overlay) {
      this.overlay.parentNode?.removeChild(this.overlay);
    }
    if (this.element.tagName.toLowerCase() == 'iframe') {
      this.element.setAttribute('src', this.element.getAttribute('data-src'));
    } else {
      this.element.type = "text/javascript";
    }
    this.element.removeAttribute('data-usercentrics');
  }
}